__turbopack_context__.v({
  "contents": "MyNaviMenuDrawer-module__0vwFVW__contents",
  "drawer": "MyNaviMenuDrawer-module__0vwFVW__drawer",
  "footer": "MyNaviMenuDrawer-module__0vwFVW__footer",
});
